<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

<div class="privacy-message-container">
	<div class="privacy-message">
		By continuing, you understand and agree that the contents of this chat may be recorded by us or
		by third parties working with us, and used as described in our <a
			href={privacyLink}
			target="_blank">Privacy Notice</a
		>. If you do not agree, please do not use our chat feature.
	</div>
	<div class="privacy-message-time">Today {$chatStartTime}</div>
</div>

<script lang="ts">
	import { brandLogos } from '$lib/utilities/brandingConfigurations';
	import { privacyNoticeUrls } from '$lib/utilities/getPrivacyLink';
	import { chatSession, chatStartTime, type ChatSessionData } from '$lib/stores/chatSessionStore';
	import { onMount } from 'svelte';
	let brandImage = brandLogos['18F'];
	let privacyLink = privacyNoticeUrls['18F'];

	const setPrivacy = async (session: ChatSessionData) => {
		brandImage = brandLogos[session.brand as keyof typeof brandLogos];
		privacyLink = privacyNoticeUrls[session.brand as keyof typeof privacyNoticeUrls];
	};
	const timeOptions: Intl.DateTimeFormatOptions = {
		hour: 'numeric',
		minute: '2-digit',
		hour12: true
	};
	if (!$chatStartTime) {
		const getCurrentTime = new Date().toLocaleTimeString('en-US', timeOptions);
		chatStartTime.set(getCurrentTime);
	}
	let unsubscribe = () => {};
	unsubscribe = chatSession.subscribe(async (session) => {
		if (session.brand) {
			unsubscribe();
			await setPrivacy(session);
		}
	});
	onMount(() => {
		const mount = async () => {
			await setPrivacy($chatSession);
		};
		mount();
	});
</script>

<style>
	.privacy-message-container {
		padding-top: 10px;
		padding-left: 32px;
		padding-right: 32px;
	}
	.privacy-message {
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-size: 10px;
		line-height: 18px;
		font-weight: 400;
		letter-spacing: 1%;
		color: #555555;
		text-align: center;
		padding: 10px;
	}
	.privacy-message-time {
		font-family: lato, sans-serif;
		font-style: normal;
		font-weight: 400;
		font-size: 12px;
		text-align: center;
		letter-spacing: 1%;
		color: #6d6d6d;
	}
</style>
